import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const Spinner = () => (
<LinearProgress />
);

export default Spinner;
